import React from "react";
import "./../styles/variable-projects.css";
import Projectsvariable from "../components/variable-projects";
import imagem1 from '../assets/images/Projetos/Transolímpica/transolimpica.jpg';
import imagem2 from '../assets/images/Projetos/Transolímpica/transolimpica-img2.jpg';
import imagem3 from '../assets/images/Projetos/Transolímpica/transolimpica-img3.jpg'

const App = () => {
  const projectData = {
    date: "17/03/2017",
    title: "Transolímpica",
    images: [
     imagem1,
     imagem2,
     imagem3
    ],
    description:
    "Cobertura indoor na Transolímpica – primeira via expressa de acesso as áreas olímpicas da cidade do Rio de Janeiro trechos cobertos:",
    solutions: ["Transolimpica – Túnel – de Curicica a Boiúna e  Deodoro a Curicica. Fornecimento de materiais de infraestrutura da Transolímpica – RJ e Parque Olímpico"],
  };

  return <Projectsvariable {...projectData} />;
};

export default App;